<nb-card [nbSpinner]="roomLocationLoading">
  <nb-card-header>
    <div class="row">
      <div class="col">
        <h2 *ngIf="editRoomLocation.id === undefined">Create Room Location</h2>
        <h2 *ngIf="editRoomLocation.id !== undefined">Edit Room Location {{editRoomLocation.name}}</h2>
      </div>
      <div class="col" style="text-align: right; color: crimson;" *ngIf="roomLocationId !== 0">
        <button mat-icon-button (click)="deleteRoomLocationClicked(RoomLocationForm);" [disabled]="!editRoomLocation.id"><i
            class="fas fa-trash-alt fa-2x"></i></button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <form #RoomLocationForm="ngForm" id="RoomLocationForm" name="RoomLocationForm" style="margin-top: 15px;">
      <div class="row">
        <div class="form-group col-12">
          <h3>Details</h3>
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="text" matInput id="name" name="name" [(ngModel)]="editRoomLocation.name"
                    placeholder='Name' [value]="editRoomLocation?.name" required #name="ngModel">
                </mat-form-field>
              </div>

              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="text" matInput id="roomLocationDescription" name="roomLocationDescription"
                    [(ngModel)]="editRoomLocation.description" placeholder='Description' [value]="editRoomLocation?.description"
                    #name="ngModel">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <input type="text" matInput id="barcode" name="barcode" [(ngModel)]="editRoomLocation.barcode"
                    placeholder='Barcode' [value]="editRoomLocation?.barcode" required #name="ngModel">
                </mat-form-field>
              </div>

              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <mat-label>
                    Warehouse
                  </mat-label>
                  <mat-select placeholder="Warehouse" name="warehouseDropdown" id="warehouseDropdown"
                    [(ngModel)]="this.warehouseId" (selectionChange)="warehouseChanged($event.value)"
                    #warehouseDropdown="ngModel">
                    <mat-option>(SELECT)</mat-option>
                    <mat-option *ngFor="let v of this.warehouses" [value]="v.id">
                      {{v.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-lg-6 col-12">
                <mat-form-field style="width: 100%">
                  <mat-label>
                    Room
                  </mat-label>
                  <mat-select placeholder="Room" name="roomDropdown" id="roomDropdown"
                    [(ngModel)]="this.editRoomLocation.roomId" (selectionChange)="roomChanged($event.value)" required
                    #roomDropdown="ngModel">
                    <mat-option>(SELECT)</mat-option>
                    <mat-option *ngFor="let v of this.rooms" [value]="v.id">
                      {{v.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-12">
                <mat-checkbox placeholder="Active?" name="isActive" id="isActive" [(ngModel)]="editRoomLocation.isActive"
                  [(value)]="editRoomLocation.isActive" #active="ngModel" color="primary">Active?</mat-checkbox>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="row" style="margin-top: 10px;">
    <div class="custom-dialog-actions">
    <div [nbSpinner]="submitting" class="btn-group">
      <button *ngIf="!submitting" type="submit" form="RoomLocationForm" (click)="saveRoomLocationClicked(RoomLocationForm);"
        [disabled]="!RoomLocationForm.valid" class="custom-button save-button">
        <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>Save
      </button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button class="custom-button cancel-button" (click)="cancelClicked(RoomLocationForm)">
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>Cancel
      </button> </div>
  </div>
  </nb-card-footer>
</nb-card>


